(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.ticking = false;
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.header = document.getElementById('shopify-section-header');
      if (!this.header) return;

      this.headerBounds = { top: 0, bottom: 0 };
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.headerObserver) {
        this.headerObserver.disconnect();
      }
    }

    setHeaderBounds() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const rect = this.header.getBoundingClientRect();

      this.headerBounds = {
        top: scrollTop + rect.top,
        bottom: scrollTop + rect.bottom
      };

      this.currentScrollTop = this.headerBounds.bottom + 300;
    }

    createObserver() {
      if (!('IntersectionObserver' in window)) {
        this.setHeaderBounds();
        return;
      }

      this.headerObserver = new IntersectionObserver((entries, observer) => {
        if (!entries.length) return;

        this.setHeaderBounds();
        observer.disconnect();
      });

      this.headerObserver.observe(this.header);
    }

    onScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.ticking = false;
        this.updateHeaderState();
      });
    }

    updateHeaderState() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const headerBottom = this.headerBounds.bottom || 0;
      const headerTop = this.headerBounds.top || 0;

      if (theme.config.mqlSmall) {
        if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
          this.hide();
        } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
          if (!this.preventReveal) {
            this.reveal();
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = window.setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            this.hide();
          }
        } else if (scrollTop <= headerTop) {
          this.reset();
        }

        this.currentScrollTop = scrollTop;
      } else {
        if (scrollTop > this.currentScrollTop) {
          this.reveal();
        } else {
          this.hide();

          if (scrollTop <= headerBottom) {
            this.reset();
          }
        }

        this.currentScrollTop = scrollTop;
      }
    }

    setErwanaNavyState(enabled) {
      this.classList.toggle('erwana-scrolled-navy', enabled);
      this.header.classList.toggle('erwana-scrolled-navy', enabled);
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.setErwanaNavyState(true);
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setErwanaNavyState(true);
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setErwanaNavyState(false);
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
